__webpack_require__.p = "/TIC-TAC-TOE/";